// @flow
import React from 'react'
import Donut from '../UI/charts/Donut'
import { BarChart, CartesianGrid, XAxis, YAxis, Bar } from 'recharts'
import { Unit } from '../AdminFloorPlan/components/MeasurementInput'
import styles from './ChartSection.module.scss'

const ChartSection = ({
  data,
  chartType,
  colName,
  description,
  unit,
}: {
  data: any
  chartType?: 'donut' | 'bar'
  colName: string
  description: string | any
  unit?: string
}) => {
  const legendEl =
    chartType === 'bar'
      ? data && data?.length > 0 && <Table data={data} colName={colName} unit={unit} />
      : data?.map(
          ({
            key,
            value,
            label,
            color,
          }: {
            key: string
            value: string
            label: string
            color: string
          }) => (
            <div key={key} className={styles.label}>
              <div className={styles.colorIndicator} style={{ backgroundColor: color }} />
              <div className={styles.truncate}>{`${value} ${label}`}</div>
            </div>
          )
        )

  const chartEl =
    chartType === 'bar' ? (
      <BarChart data={data} width={160} height={140}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="x" />
        <YAxis dataKey="y" />
        <Bar dataKey="key" fill="#8884d8" />
      </BarChart>
    ) : (
      <Donut showLabel={true} unit={unit} data={data} title="" />
    )

  return (
    <div className={styles.chartSection}>
      <div style={{ paddingTop: chartType === 'bar' ? 15 : 0 }}>
        {legendEl}
        {React.isValidElement(description) && description}
        {typeof description === 'string' && (
          <div className={styles.descriptionsSection}>{description}</div>
        )}
      </div>
      {chartEl}
    </div>
  )
}

export default ChartSection

const Table = ({ colName, data, unit }: any) => (
  <table className={styles.table}>
    <tbody>
      <tr>
        <th className={styles.header}>count</th>
        <th className={styles.header}>{colName || <Unit unit={unit} />}</th>
      </tr>
    </tbody>
    <tbody>
      {data?.map(({ key, x, y }: { key: number; x: number; y: number }) => (
        <tr key={key}>
          <td className={styles.tableCell}>{y}</td>
          <td className={styles.tableCell}>{x}</td>
        </tr>
      ))}
    </tbody>
  </table>
)
